var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"OLegend"},[_c('h4',[_vm._v("Legend")]),_c('ul',_vm._l((_vm.pageHeaders),function(header,index){return _c('li',{key:index,staticClass:"is-clickable as-link p-4",on:{"click":() => _vm.scrollIntoView(header)}},[_vm._v(" "+_vm._s(header.innerText)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }